import { SearchBaseIconRaw } from '@tableau/icons/SearchBaseIcon/raw';
import { Colors } from '@tableau/icons/util/Colors';

import { style } from 'typestyle';
import { NestedCSSSelectors } from 'typestyle/lib/types';

import { CommonStyles } from '../../commonInfra/styles/CommonStyles';
import { SearchBoxIconSize } from '../common/Constants';


const IconColors = {
    Rest: Colors.Default,
    Focus: '#2e2e2e',
    Hover: '#2e2e2e',
    Disabled: '#c9c9c9',
}

const searchIcon = { svg: (color: string) => encodeSvgUrl(SearchBaseIconRaw(SearchBoxIconSize, color)) }

function encodeSvgUrl(svg: string): string {
    return `url('data:image/svg+xml,${encodeURIComponent(svg)}')`;
}

export const omnibox = style({
    display: 'inline-block',
    position: 'relative',
    textAlign: 'left',
    maxWidth: 'initial',
    height: 32,
    $nest:{
        '&.for-serp input#search-omnibox': {
            width: '100%'
        }
    }
}, { $debugName: 'omnibox' });

export const searchBox = style({
    display: 'flex',
    backgroundColor: '#fff',

    $nest: {
        '& input#search-omnibox': {
            width: 370,
            height: 32,
            fontSize: 14,
            paddingLeft: 36,
            backgroundPosition: 9,
            backgroundSize: 20,
            backgroundImage: searchIcon.svg(IconColors.Rest) + '!important',
            transition: 'width 0.25s ease-in-out',
            $nest: {
                '&:hover:enabled:not(:focus)': { backgroundImage: searchIcon.svg(IconColors.Hover) + '!important', },
                '&:focus': { backgroundImage: searchIcon.svg(IconColors.Focus) + '!important', },
                '&:disabled': { backgroundImage: searchIcon.svg(IconColors.Disabled) + '!important', },
                '&:placeholder-shown': {
                    textOverflow: 'ellipsis',
                }
            }
        }        
    }
}, { $debugName: 'search-box' });

export const searchBoxLong = style({
    $nest: {
        ' input#search-omnibox': {
            width: 562,
        }
    }
}, { $debugName: 'search-box-long' });

export const pressEnterToSeeAll = style({
    paddingTop: 7,
    position: 'absolute',
    right: 14,
    pointerEvents: 'none',
    fontSize: 14
}, { $debugName: 'press-enter-to-see-all' })



export const section = style({
    overflow: 'hidden',
    margin: '0 16px',
    paddingTop: 12,
    paddingBottom: 12
});

export const sectionHeader = style({
    color: CommonStyles.Colors.NormalTextColor,
    display: 'flex',
    alignItems: 'center',
    height: 32,
});

export const focusBorder = style({
    outline: `1px solid ${CommonStyles.Colors.FocusBorderBlue}`,
    border: `1px solid transparent`,
    boxShadow: `0 0 4px 0 ${CommonStyles.Colors.FocusBorderBlue}`
});

export const sectionHeaderTitle = style({
    color: CommonStyles.Colors.NormalTextColor,
    fontWeight: 'bold',
    fontSize: 14,
    padding: '8px 8px 0',
    margin: 0,
    display: 'block'
});

const sectionItemNest: NestedCSSSelectors = {
    '&:hover, &:focus, &:visited': {
        backgroundColor: CommonStyles.Colors.Grey229,
        color: CommonStyles.Colors.Grey46,
        textDecoration: 'none',
        outline: '1px solid #939393',
        outlineOffset: '-1px'
    },
    '&:active': {
        backgroundColor: CommonStyles.Colors.Grey201
    }
};

export const activeSectionItem = 'activeSectionItem';

sectionItemNest['&.' + activeSectionItem] = {
    backgroundColor: CommonStyles.Colors.Grey229,
    outline: '1px solid #939393',
    outlineOffset: '-1px'
};

export const sectionItem = style({
    color: CommonStyles.Colors.NormalTextColor,
    textDecoration: 'none',
    fontSize: 14,
    height: 32,
    $nest: sectionItemNest
});

export const sectionItemHorizontalLayout = style({
    display: 'flex',
    alignItems: 'center',
});

export const sectionItemFixedContent = style({
    flex: '0 0 auto'
});

export const sectionItemAutoFitContent = style({
    flex: '1 1 auto'
});

export const querySuggestionSection = style({
    paddingTop: '12px'
});

export const jumpBackInSection = style({
    paddingTop: '12px'
});

export const querySuggestionItem = style({
    fontSize: 14
});

export const querySuggestionItemIcon = style({
    marginRight: 8,
    height: 32,
    width: 32,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

export const ownerSection = style({
    paddingBottom: 2
});

export const contentSuggestionSection = style({
    paddingBottom: 0
});

export const contentSuggestionSectionItem = style({
    height: 'auto',
    padding: '8px',
});

export const contentSuggestionSectionItemIcon = style({
    color: CommonStyles.Colors.Grey46,
});

export const contentSuggestionExtraIcons = style({
    $nest: {
        'svg': {
            transform: 'translate(0,2px)'
        },
    }
});


export const alignCenter = style({
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
});

export const contentSuggestionSectionItemContent = style({
    marginLeft: 13,
    width: 470,
    $nest: {
        'em': {
            fontStyle: 'unset',
            fontWeight: 'bold'
        },
    }
});

export const draftIndicator = style({
    marginLeft: 13,
});

export const sectionBottomBorder = style({
    borderBottom: '1px solid #e6e6e6'
});

export const useColorForHighlight = style({
    $nest: {
        'em': {
            color: CommonStyles.Colors.HyperlinkBlue
        },
        'a strong': {
            color: CommonStyles.Colors.HyperlinkBlue
        }
    }
});